export default {
  items: [
    "Afrikaans",
    "Amharic",
    "Arabic",
    "Auslan",
    "Bemba",
    "Bengali",
    "Bisaya",
    "Bosnian",
    "Burmese",
    "Cantonese",
    "Chin Haka",
    "Croatian",
    "Czech",
    "Danish",
    "Dari",
    "Dinka",
    "French",
    "German",
    "Greek",
    "Gujarati",
    "Hakka",
    "Hazaraghi",
    "Hebrew",
    "Hindi",
    "Hungarian",
    "Indonesian",
    "Italian",
    "Japanese",
    "Kannada",
    "Karen",
    "Khmer",
    "Kirundi",
    "Korean",
    "Kriol",
    "Kurdish",
    "Macedonian",
    "Malay",
    "Malayalam",
    "Mandarin",
    "Marathi",
    "Mauritian Creole",
    "Min Nan",
    "Nepali",
    "Persian (excluding Dari)",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Romanian",
    "Russian",
    "Samoan",
    "Serbian",
    "Shona",
    "Sinhalese",
    "Somali",
    "Spanish",
    "Swahili",
    "Tagalog",
    "Tamil",
    "Telugu",
    "Thai",
    "Tigrinya",
    "Turkish",
    "Ukrainian",
    "Urdu",
    "Vietnamese"
  ]
}



// WEBPACK FOOTER //
// ../data/wa/language.js